import * as z from "zod";
import { normalizeName } from "../normalizeName";
import { mutator } from "./mutator";

export const setUserName = mutator({
  schema: z.object({
    name: z
      .string()
      .transform(normalizeName)
      .refine((s) => s.length > 0, { message: "Name must not be empty" }),
  }),
  resolve: {},
  permissions: { none: "updates only the calling user’s own name" },
  fn: async ({ tx, ctx, args }) => {
    await tx.mutate.user.update({ id: ctx.userId, name: args.name });
  },
});
